import QRCodeContainer from './qrcode-container';

export default QRCodeContainer;
